import React, { useState } from 'react';
import { Grid, Divider, Typography, TextField, Button, Avatar, IconButton, InputAdornment } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/styles';
import { Box } from '@mui/material';
import InputMask from 'react-input-mask';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CheckCircleOutline, ErrorOutline } from '@material-ui/icons';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',

    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: 'bold',
        fontFamily: 'montserrat',
        color: '#686b72'
    },
    informationHeading: {
        fontSize: 14,
        fontFamily: 'montserrat',
        color: '#686b72'
    },
    TypographyData: {
        fontFamily: 'montserrat',
        fontSize: 12,
        color: '#686b72',
    },
    TypographyDataLeft: {
        fontFamily: 'montserrat',
        fontSize: 12,
        color: '#686b72',
        marginLeft: -26
    },
    TextField: {
        width: '100%',
        height: '10%'
    }
}));

const InformationEmployeeForm = ({
    viewEmployeeRegistration,
    handleExpandClick
}) => {
    const classes = useStyles()

    const isCpfValid = (cpf) => {
        try {
            // Remove caracteres não numéricos
            const cleanedCpf = cpf?.replace(/\D/g, '');

            // Verifica se o CPF tem 11 dígitos
            if (cleanedCpf.length !== 11) {
                return false;
            }

            // Verifica se o CPF não é uma sequência de números iguais
            if (/^(\d)\1+$/.test(cleanedCpf)) {
                return false;
            }

            // Padrão da máscara
            const cpfPatternWithoutMask = /^\d{11}$/;
            const cpfPatternWithMask = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;

            // Verifica se o CPF está no formato com máscara ou sem máscara
            return cpfPatternWithMask.test(cpf) || cpfPatternWithoutMask.test(cleanedCpf);
        } catch (error) {
            return false;
        }
    };

    const isPhoneValid = (phone) => {
        try {
            // Remove caracteres não numéricos
            const cleanedPhone = phone?.replace(/\D/g, '');

            // Verifica se o telefone tem 11 dígitos
            if (cleanedPhone.length !== 11) {
                return false;
            }

            // Padrões da máscara
            const phonePatternWithoutMask = /^\d{11}$/;
            const phonePatternWithMask = /^\(\d{2}\) \d{5}-\d{4}$/;

            // Verifica se o telefone está no formato com máscara ou sem máscara
            return phonePatternWithMask.test(phone) || phonePatternWithoutMask.test(cleanedPhone);

        } catch (error) {
            return false;
        }
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Divider style={{ marginTop: -20 }} />
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={5} justify='flex-start'>
                        <Typography className={classes.TypographyDataLeft}>
                            Nome completo (Obrigatório)
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            // id = "outlined-required"
                            required={true} // Isso torna o campo obrigatório
                            className={classes.TextField}
                            variant="outlined"
                            value={viewEmployeeRegistration.dataInformation.name}
                            InputProps={{
                                style: {
                                    ...styles.InputLeft,
                                    backgroundColor: viewEmployeeRegistration.dataInformation?.name ? '#ddf6e4' : 'white', // Muda a cor de fundo
                                    borderColor: viewEmployeeRegistration.dataInformation?.name ? 'green' : 'gray', // Muda a cor da borda
                                },
                                endAdornment: viewEmployeeRegistration.dataInformation?.name ? (
                                    <InputAdornment position="end">
                                        <CheckCircleOutline style={{ color: 'green' }} />
                                    </InputAdornment>
                                ) : null,
                            }}
                            onChange={event => viewEmployeeRegistration.handleChangeInformationForm(event, 'name')}
                        />
                    </Grid>
                    <Grid item xs={5}>

                        <Typography className={classes.TypographyData}>
                            CPF (Obrigatório)
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            className={classes.TextField}
                            required={true}
                            variant="outlined"
                            value={viewEmployeeRegistration.dataInformation?.cpf}
                            InputProps={{
                                style: {
                                    ...styles.InputRight,
                                    backgroundColor: viewEmployeeRegistration.dataInformation?.cpf ?
                                        isCpfValid(viewEmployeeRegistration.dataInformation?.cpf) ? '#ddf6e4' : '#F3C7C7FF' : 'white', // Muda a cor de fundo
                                    borderColor: viewEmployeeRegistration.dataInformation?.cpf ?
                                        isCpfValid(viewEmployeeRegistration.dataInformation?.cpf) ? 'green' : 'red' : 'gray',
                                },
                                inputComponent: InputMask,
                                inputProps: {
                                    mask: '999.999.999-99',
                                },
                                endAdornment: viewEmployeeRegistration.dataInformation?.cpf ? (
                                    <InputAdornment position="end">
                                        {
                                            isCpfValid(viewEmployeeRegistration.dataInformation?.cpf) ?
                                                <CheckCircleOutline style={{ color: 'green' }} />
                                                :
                                                <ErrorOutline style={{ color: 'red' }} />
                                        }

                                    </InputAdornment>
                                ) : null,
                            }}
                            onChange={event => viewEmployeeRegistration.handleChangeInformationForm(event, 'cpf')}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <Typography className={classes.TypographyDataLeft}>
                            Telefone (Obrigatório)
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            className={classes.TextField}
                            variant="outlined"
                            value={viewEmployeeRegistration.dataInformation?.phone}
                            InputProps={{
                                style: {
                                    ...styles.InputLeft,
                                    backgroundColor: viewEmployeeRegistration.dataInformation?.phone ?
                                        isPhoneValid(viewEmployeeRegistration.dataInformation?.phone) ? '#ddf6e4' : '#F3C7C7FF' : 'white', // Muda a cor de fundo
                                    borderColor: viewEmployeeRegistration.dataInformation?.phone ?
                                        isPhoneValid(viewEmployeeRegistration.dataInformation?.phone) ? 'green' : 'red' : 'gray',
                                },
                                inputComponent: InputMask,
                                inputProps: {
                                    mask: '(99) 99999-9999',
                                },
                                endAdornment: viewEmployeeRegistration.dataInformation?.phone ? (
                                    <InputAdornment position="end">
                                        {
                                            isPhoneValid(viewEmployeeRegistration.dataInformation?.phone) ?
                                                <CheckCircleOutline style={{ color: 'green' }} />
                                                :
                                                <ErrorOutline style={{ color: 'red' }} />
                                        }
                                    </InputAdornment>
                                ) : null,
                            }}
                            required={true}
                            onChange={event => viewEmployeeRegistration.handleChangeInformationForm(event, 'phone')}
                        />

                    </Grid>
                    <Grid item xs={5}>
                        <Typography className={classes.TypographyData}>
                            Data de nascimento (Obrigatório)
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            type="date"
                            className={classes.TextField}
                            variant="outlined"
                            value={viewEmployeeRegistration.dataInformation.dateOfBird}
                            InputProps={{
                                style: styles.InputRight,
                                inputProps: {
                                    max: "9999-12-31", // Define o valor máximo permitido
                                },
                            }}
                            onChange={event => viewEmployeeRegistration.handleChangeInformationForm(event, 'dateOfBird')}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <Typography className={classes.TypographyDataLeft}>
                            CEP
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            // style={{ width: '100%' }}
                            className={classes.TextField}
                            variant="outlined"
                            value={viewEmployeeRegistration.dataInformation.cep}
                            InputProps={{
                                style: styles.InputLeft,
                                inputComponent: InputMask,
                                inputProps: {
                                    mask: "99999-999",
                                },
                            }}
                            onChange={event => viewEmployeeRegistration.handleChangeInformationForm(event, 'cep')}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <Typography className={classes.TypographyData}>
                            Endereço residencial
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            className={classes.TextField}
                            variant="outlined"
                            value={viewEmployeeRegistration.dataInformation.address}
                            InputProps={{
                                style: styles.InputRight
                            }}
                            onChange={event => viewEmployeeRegistration.handleChangeInformationForm(event, 'address')}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Divider style={{ marginTop: 30 }} />
            </Grid>
            <Grid item xs={5} />
            <Grid item xs={7} container justify="flex-end" style={{ marginLeft: -10 }}>
                {
                    viewEmployeeRegistration.loading ?
                        <CircularProgress />
                        :
                        <>
                            <Button
                                style={{
                                    ...styles.buttonOne,
                                    color: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.atualizationButton ? '#484fdb' : '#c3c3c3'
                                }}
                                onClick={() => viewEmployeeRegistration.handleClickDiscard('employeeForm')}
                            >
                                Descartar atualizações
                            </Button>
                            <Button style={{
                                ...styles.buttonTwo,
                                backgroundColor: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.atualizationButton ? '#484fdb' : 'white',
                                color: viewEmployeeRegistration.isUpdate ? 'white' : viewEmployeeRegistration.atualizationButton ? 'white' : '#c3c3c3'
                            }}
                                onClick={viewEmployeeRegistration.createdEmployee}
                            >
                                {viewEmployeeRegistration.isUpdate ? 'Salvar' : 'Próximo'}
                            </Button>
                        </>
                }
                <Box style={styles.Box} />
                <Avatar style={{ ...styles.avatar }}>
                    <IconButton onClick={() => viewEmployeeRegistration.handleExpandClick('dataPerson')} style={{ padding: 0 }}>
                        <ExpandMoreIcon style={{ fontSize: 20, color: viewEmployeeRegistration.isUpdate ? '#484fdb' : '#c3c3c3' }} />
                    </IconButton>
                </Avatar>
            </Grid>

        </Grid >
    );
};


export default InformationEmployeeForm;

const styles = {
    InputLeft: {
        height: 40,
        padding: '0 14px',
        borderRadius: 10,
        marginLeft: -26,
        fontFamily: 'montserrat',
        fontSize: 13,
        color: '#64656d',
        fontWeight: 'bold'
    },
    InputRight: {
        height: 40,
        padding: '0 14px',
        borderRadius: 10,
        marginRight: -25,
        fontFamily: 'montserrat',
        fontSize: 13,
        color: '#64656d',
        fontWeight: 'bold'
    },
    buttonOne: {
        backgroundColor: 'white',
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '35%',
        height: 30,
        marginLeft: -10,
        marginRight: 10,
        fontFamily: 'montserrat',
        fontSize: 10,
        fontWeight: 'bold',
        whiteSpace: 'nowrap'

    },
    buttonTwo: {
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '16%',
        height: 30,
        marginRight: 10,
        fontFamily: 'montserrat',
        fontSize: 10,
        fontWeight: 'bold'
    },
    Box: { borderLeft: '1px solid #c3c3c3', height: '30px', marginLeft: '10px', marginRight: 10 },
    avatar: { backgroundColor: 'white', border: '1px solid #c3c3c3', width: 30, height: 30, transform: 'rotate(180deg)' }
}
